/*LIBRARY*/
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import icon_product from "../../Assets/png_jpg/icon_product.png";

/*FUNCTION*/
import dict from "../../Data/dict.json";
import { block_license_with_handler } from "../../App/actions/filter_license";

/*DATA*/

/*CONST*/

const NO_LICENSE = ({ auth, block_license_with_handler }) => {
  const toggle_payment_table = () => {
    block_license_with_handler();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props

  //content

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Full viewport height for a proper blocking page
          width: "100%",
          backgroundColor: "#f8f9fa", // Light clean background
          textAlign: "center",
          padding: "20px",
          boxSizing: "border-box",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "40px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxWidth: "500px",
            width: "100%",
          }}
        >
          <img
            src={icon_product}
            alt="MAPID PRODUCT"
            width="100"
            style={{ marginBottom: "24px" }}
          />

          <h1
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#2d3748",
              margin: "0 0 12px 0",
            }}
          >
            {dict?.["Feature could not be loaded"]?.[language]}
          </h1>

          <p
            style={{
              fontSize: "15px",
              color: "#718096",
              lineHeight: "1.6",
              margin: "0 0 32px 0",
            }}
          >
            {
              dict?.[
                "You do not have a GEO MAPID license yet. Purchase a license to access this feature."
              ]?.[language]
            }
          </p>

          <button
            onClick={toggle_payment_table}
            className="button_big hover_primary"
            style={{ marginBottom: "16px" }}
          >
            {dict?.["View Plans"]?.[language]}
          </button>

          <Link
            to="/dashboard"
            style={{
              color: "#3182ce",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "14px",
              marginTop: "8px",
            }}
          >
            {dict?.["Back to Home"]?.[language] || "Back to Home"}
          </Link>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  block_license_with_handler,
})(NO_LICENSE);
